import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} అనామక చాట్ హోమ్`,
    languageButtonLabel: `భాష`,
    languageModalTitle: `భాషను ఎంచుకోండి`,
    languageModalCloseLabel: `భాష మెను మూసివేయండి`,
  },
  languageOptions: {
    'en-US': {
      label: `ఇంగ్లీష్ (యునైటెడ్ స్టేట్స్)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `ఇంగ్లీష్ (కెన్యా)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `ఇంగ్లీష్ (నైజీరియా)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `ఇంగ్లీష్ (సింగపూర్)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `పోర్చుగీస్ (పోర్చుగల్)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `పోర్చుగీస్ (బ్రెజిల్)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `జర్మన్ (జర్మనీ)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `జర్మన్ (ఆస్ట్రియా)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `జర్మన్ (స్విట్జర్లాండ్)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `స్పానిష్ (స్పెయిన్)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `ఫ్రెంచ్ (ఫ్రాన్స్‌)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `ఇటాలియన్ (ఇటలీ)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `డచ్ (నెదర్లాండ్స్)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `పోలిష్ (పోలాండ్)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `స్వీడిష్ (స్వీడన్)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `డానిష్ (డెన్మార్క్)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `ఫిన్నిష్ (ఫిన్లాండ్)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `నార్వేజియన్ (నార్వే)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `ఐస్లాండిక్ (ఐస్లాండ్)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `జపనీస్ (జపాన్)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `కొరియన్ (దక్షిణ కొరియా)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `చైనీస్ (చైనా)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `కాంటనీస్ (హాంకాంగ్ ఎస్ఏఆర్ చైనా)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `వియత్నామీస్ (వియత్నాం)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `థాయ్ (థాయిలాండ్)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `ఇండోనేషియన్ (ఇండోనేషియా)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `స్వాహిలి (కెన్యా)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `హిందీ (భారతదేశం)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `బంగ్లా (బంగ్లాదేశ్)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `మరాఠీ (భారతదేశం)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు (భారతదేశం)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `పర్షియన్ (ఇరాన్)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `ఉర్దూ (పాకిస్తాన్)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `పంజాబీ (పాకిస్తాన్)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `నైజీరియన్ పిడ్గిన్ (నైజీరియా)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `రష్యన్ (రష్యా)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `అరబిక్ (సౌదీ అరేబియా)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `అరబిక్ (యునైటెడ్ అరబ్ ఎమిరేట్స్)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `అరబిక్ (ఖతార్)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `మొరాక్కో అరబిక్`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `టర్కిష్ (తుర్కియె)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `భాషను ఎంచుకోండి`,
    closeLabel: `భాష మెను మూసివేయండి`,
  },
  languageHint: (ctx) => `ఖాతా అవసరం లేకుండా ${ctx.localesCount}+ భాషల్లోకి దూకండి.`,
  readPagePrompt: ({languageLabel}) => `ఈ పేజీని ${languageLabel} లో చదవండి.`,
};
